"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveMappingTables = void 0;
const logger_1 = require("@sundaysky/logger");
const deepmerge_1 = __importDefault(require("deepmerge"));
const dtclient = __importStar(require("./dtclient"));
const dtaasUtils_1 = require("./dtaasUtils");
const log = (0, logger_1.logger)("mapping");
// map dtKey -> table name
const mapByDtKey = (tableDefs, tables) => {
    return tables.reduce((acc, table) => {
        var _a;
        const dtKey = (_a = tableDefs[table]) === null || _a === void 0 ? void 0 : _a.dtKey;
        if (dtKey) {
            acc[dtKey] = table; // map dtKey -> table name
        }
        else {
            log.error("Skipping Mapping Table ", table, " Because No DT Key Defined");
        }
        return acc;
    }, {});
};
const lookupMappingTables = (tableDefs, tableData, context, passthroughHeaders, dtaasEndpoint) => __awaiter(void 0, void 0, void 0, function* () {
    if (!tableData || !tableData.tables)
        return {};
    tableDefs = tableDefs || {};
    // map dtkey -> tableName
    const dtKeysAndNames = mapByDtKey(tableDefs, tableData.tables);
    const dtKeys = Object.keys(dtKeysAndNames);
    if (!dtKeys || dtKeys.length === 0) {
        return {};
    }
    const normalizedContext = (0, dtaasUtils_1.normalizeDtaasContext)(context);
    const resultByDtKey = yield dtclient.post({ inputs: normalizedContext, lookup: dtKeys }, passthroughHeaders, dtaasEndpoint);
    return Object.keys(resultByDtKey).reduce((acc, dtKey) => {
        acc[dtKeysAndNames[dtKey]] = resultByDtKey[dtKey];
        return acc;
    }, {});
});
const resolveMappingTables = (repos, story, context, dtaasEndpoint, passthroughHeaders) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let result = yield lookupMappingTables(repos.tables, story.tableData, context, passthroughHeaders, dtaasEndpoint);
    // wrap, if requested
    let root = (_a = story.tableData) === null || _a === void 0 ? void 0 : _a.rootElement;
    if (root) {
        result = { [root]: result };
    }
    // place into the context
    context = (0, deepmerge_1.default)(context, result);
    return context;
});
exports.resolveMappingTables = resolveMappingTables;
//# sourceMappingURL=mapping.js.map